// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"s0-z","displaySixCardTiles":"t0-z"};